import * as yup from 'yup';
import { LegalEntity, ShareholderType, CountryCode, } from '../../types';
import { AppliedProductId } from '../../types/AppliedProductId';
yup.addMethod(yup.string, 'validUrl', function (errorMessage) {
    return this.test('test-valid-url', errorMessage, (value) => {
        if (!value) {
            return true;
        }
        let url;
        try {
            url = new URL(value);
        }
        catch (_) {
            return false;
        }
        return url.protocol === 'http:' || url.protocol === 'https:';
    });
});
export const registrationAttributesSchema = yup
    .array()
    .of(yup.object({
    name: yup.string().required(),
    value: yup.string().required(),
}))
    .optional();
/** Merchant Registrative Session */
export const merchantRegistrationSessionSchema = yup
    .object({
    appliedProductId: yup
        .string()
        .oneOf(Object.values(AppliedProductId)) // todo: make this configurable
        .lowercase()
        .required(),
    merchantId: yup.string().max(36).required(),
    accountNickname: yup.string().max(50).optional(),
    firstName: yup.string(),
    lastName: yup.string(),
    phone: yup.string(),
    website: yup.string(),
    email: yup.string().email(),
    legalBusinessName: yup.string(),
    legalEntity: yup.mixed().oneOf(Object.values(LegalEntity)).default(LegalEntity.Business),
    countryCode: yup.string().length(2).required(),
    locale: yup.string().required(),
    referenceData: yup.string().optional(),
    returnUrl: yup.string().validUrl('Must provide a valid URL').optional(),
    tenantId: yup.string().optional(),
    epicDataContext: yup.string().optional(),
    epicEnvironment: yup.string().optional(),
    clientId: yup.string().optional(),
    registrationAttributes: registrationAttributesSchema,
})
    .required();
export const merchantRegistrationResumeSchema = yup.object({
    accountHolderCode: yup.string().required(),
});
/** Merchant Registrative Retrieve */
export const merchantRegistrationRetrieveRequestSchema = yup.object({
    sessionId: yup.string().required(),
});
/** Merchant Registrative Update */
export const merchantRegistrationUpdateRequestSchema = yup.object({
    accountHolderCode: yup.string().required(),
    status: yup.string().required().oneOf(['DELETED']),
});
/** Register merchant */
export const merchantRegistrationSchema = yup
    .object({
    sessionId: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    phone: yup.string().required(),
    website: yup.string().required(),
    email: yup.string().email().required(),
    legalBusinessName: yup.string().required(),
    shareholderType: yup.mixed().oneOf(Object.values(ShareholderType)).required(),
    jobTitle: yup.string().required(),
    legalEntity: yup.mixed().oneOf(Object.values(LegalEntity)).required(),
    countryCode: yup.string().length(2).required(),
    locale: yup.string().required(),
    accountNickname: yup.string().max(50).required(),
    producerLicenseNumber: yup.string().when('countryCode', {
        is: CountryCode.US,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
    }),
})
    .required();
/** Merchant Account Status Sync */
export const syncMerchantAccountStatusSchema = yup.object({
    accountHolderCode: yup.string().required(),
});
//# sourceMappingURL=merchantRegistration.js.map